export function checkIncludeArray(childArray, parentArray) {
    return childArray.every((r) => parentArray.includes(r));
}

export function removeItems(childArray, parentArray) {
    return parentArray.filter((v) => {
        return !childArray.includes(v);
    });
}
